import { AppStage, FeatureConfig, ToggledFeature } from "@shared/models/featureToggle";

class FeatureToggleService {
  private readonly [ToggledFeature.DefaultLandingPage]: FeatureConfig = {
    [AppStage.Dev]: false,
    [AppStage.Local]: false,
    [AppStage.Qa]: false,
    [AppStage.Sec]: false,
    [AppStage.Uat]: false,
    [AppStage.Prod]: false,
  };

  private readonly [ToggledFeature.MyCalendar]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: true,
    [AppStage.Uat]: true,
    [AppStage.Prod]: true,
  };

  private readonly [ToggledFeature.GoogleAnalytics]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: false,
    [AppStage.Qa]: true,
    [AppStage.Sec]: true,
    [AppStage.Uat]: false,
    [AppStage.Prod]: false,
  };

  private readonly [ToggledFeature.AccountFundAccess]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: false,
    [AppStage.Uat]: true,
    [AppStage.Prod]: false,
  };

  private readonly [ToggledFeature.ManageContacts]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: false,
    [AppStage.Uat]: true,
    [AppStage.Prod]: false,
  };

  private readonly [ToggledFeature.GroupEmail]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: false,
    [AppStage.Uat]: true,
    [AppStage.Prod]: true,
  };

  private readonly [ToggledFeature.MyProfile]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: true,
    [AppStage.Uat]: true,
    [AppStage.Prod]: true,
  };

  private readonly [ToggledFeature.ExpandedWireInstructions]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: true,
    [AppStage.Uat]: false,
    [AppStage.Prod]: false,
  };

  private readonly [ToggledFeature.BrightcoveVideo]: FeatureConfig = {
    [AppStage.Dev]: true,
    [AppStage.Local]: true,
    [AppStage.Qa]: true,
    [AppStage.Sec]: false,
    [AppStage.Uat]: true,
    [AppStage.Prod]: true,
  };

  private readonly [ToggledFeature.DatadogRum]: FeatureConfig = {
    [AppStage.Dev]: false,
    [AppStage.Local]: false,
    [AppStage.Qa]: true,
    [AppStage.Sec]: false,
    [AppStage.Uat]: true,
    [AppStage.Prod]: true,
  };
  public isFeatureEnabled(feature: ToggledFeature) {
    const stage = process.env.REACT_APP_STAGE as AppStage;
    const config = this[feature];

    return config[stage] ?? false;
  }
}

export default new FeatureToggleService();
